import { compose } from 'recompose'
import { connect } from 'react-redux'
import { sendPrequalRequestForClient } from '../../../../../../../actions/affordability'
import {
  selectCustomerPhotoUri,
  selectCustomerFirstName,
  selectCustomerHasSponsor
} from '../../../../../../../store/selectors/customerProfile'

import { selectSponsorshipPhotoUri, selectSponsorshipFullName } from '../../../../../../../store/selectors/sponsorship'

const GetPrequalContainer = compose(
  connect(
    state => ({
      customerProfileFirstName: selectCustomerFirstName(state),
      customerProfilePhotoUri: selectCustomerPhotoUri(state),
      isSponsored: selectCustomerHasSponsor(state),
      sponsorProfileFullName: selectSponsorshipFullName(state),
      sponsorPhotoUri: selectSponsorshipPhotoUri(state)
    }),
    dispatch => ({
      onRequest: trackingClient =>
        dispatch(
          sendPrequalRequestForClient(trackingClient, { uiContext: 'Tune Your Budget Modal - Prequalify Tab (No previous prequal)' })
        )
    })
  )
)

export default GetPrequalContainer
